<template>
  <div id="boost-anbefaling" class="animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader class="hide">
      </WebshopHeader>
      <div class="py4 px3">
        <div class="pt2"></div>
        <h4 class="darkblue bold">Boost en anbefaling på facebook</h4>
        <p class="gibson mediumgrey"></p>
        <div class="py3">
          <div class="p0">
            <div class="clearfix" v-if="insideLoading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div id="review" class="hide">
              <div class="col-12 p0" v-if="reviewMsg == ''">
                <!-- eslint-disable -->
                <!-- <div class="lg-col-3 md-col-12 pl0 pb2 mb2" v-for="(review,index) in reviewData" :key="index" v-if="reviewId == review.ReviewId">
                  <div class="overflow-hidden">
                    <div class="flex flex-column mt1">
                      <div class="flex justify-between items-center">
                        <div>
                          <image-rating v-model="review.Rating" src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="22" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
                        </div>
                        <div>
                          <span v-if="review.AssignmentDistributedCount === 1" class="green">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
                          </span>
                          <span v-else class="mediumgrey">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -1.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-shield-check-f"><path d='M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z' /></svg>
                          </span>
                        </div>
                      </div>
                    </div>
                    <p class="darkblue">{{review.RatedDate}}</p>
                    <div class="flex">
                    <span  :data-key="index" ref="tex" class="h5 bold text-overflow-handle" @click="showlesss(index)" >{{review.RatedBy}}</span>
                    </div>
                    <div class="pb2"></div>
                    <el-collapse class="border-none">
                      <el-collapse-item title="Kommentar" :name="index">
                      <p class="gibson mediumgrey break-word">{{review.RatingComment}}</p>
                      </el-collapse-item>
                    </el-collapse>
                    <div class="pb2">
                      <div class="pb2"></div>
                      <div class="block">
                        <b-form-input :id="'amount'+review.ReviewId" type="number" placeholder="Beløb her" class="amount mb1" :min="200">
                        </b-form-input>
                        <b-button type="button" class="action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12" @click="boostRecommendation(review.ReviewId, 'facebook')">Boost på facebook <i class="fab fa-facebook-f"></i>
                        </b-button> -->
                        <!-- <b-button type="button" class="action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12" @click="boostRecommendation(review.ReviewId, 'google')">Boost på google  <i class="fab fa-google"></i>
                        </b-button> -->
                 <!--      </div>
                    </div>
                  </div>
                </div> -->
                <!-- eslint-enable -->
                <div class="lg-col-3 md-col-12 highlights pt2 px2 pb0 break-word">
                  <div class="flex mb2">
                    <div class="col-1 p0">
                      <img src="static/svg/h.svg" rel="preload" width="100%">
                    </div>
                    <div class="col-10">
                      <h6 class="bold m0" style="font-size: 0.9rem;">Find handvaerkere i Hovedstaden 4.0</h6>
                      <div class="flex">
                        <p class="mediumgrey mr1 mb0" style="font-size: 0.9rem;">Sponsored</p>
                        <img src="static/svg/globe-asia.svg" rel="preload" width="5%">
                      </div>
                    </div>
                    <div class="col-1 t p0">
                      <p class="text-center">...</p>
                    </div>
                  </div>
                  <div style="color:#003645;">
                    <p class="semi-bold mb2">NY ANBEFALING! 👏 <br>
                      {{reviewData.SupplierName}} har netop modtaget en anbefaling på {{reviewData.Rating}} stjerner, fordi Håndværker.dk har lavet det perfekte match <span class="h4 red">❤</span>
                    </p>
                    <p class="semi-bold mb2">Den glade kunde fortæller "{{reviewData.RequesterName}} : {{reviewData.RequesterComment}}"
                    </p>
                    <p class="semi-bold mb2">{{reviewData.SupplierName}} har TLF: {{reviewData.SupplierPhoneNr}} og du kan se deres andre ratings her <br>
                      <a :href="overviewData.url+'/'+this.reviewId" class="no-hover" target="_blank">{{overviewData.url+'/'+this.reviewId}}</a>
                    </p>
                  </div>
                  <img :src="'https://widget.haandvaerker.dk/banners/Sharefbpng.php?id='+this.reviewId" rel="preload" width="100%" @load="imageLoaded()">
                </div>
                <div class="flex lg-col-3 md-col-12 highlights p2 muted-background">
                  <div class="col-7 p0 text-left" style="color:#1C2028;">
                    <p class="m0">HÅNDVÆRKER.DK</p>
                    <p class="bold m0">{{reviewData.SupplierName}}</p>
                    <div class="flex" v-if="!insideLoading">
                      <p class="m0" style="font-size: 0.9rem;" v-html="overviewData.Description.substring(0, 30)"></p>
                      <p class="m0" v-if="overviewData.Description.length >= 30">...</p>
                    </div>
                  </div>
                  <div class="col-5 p0 text-center my-auto">
                    <a :href="overviewData.url+'/'+this.reviewId" class="no-hover border darkblue darkblue-border p1" target="_blank" style="border-color: #003645 !important;">CONTACT US</a>
                  </div>
                </div>
                <div class="lg-col-3 md-col-12 highlights p2">
                  <b-form-input id="amount" placeholder="Beløb her" class="amount mb1" @input="formatAmount()">
                  </b-form-input>
                  <b-button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular col-12" @click="confirmBoost(reviewId, 'facebook')">Boost på facebook <i class="fab fa-facebook-f"></i>
                  </b-button>
                  <!-- <b-button type="button" class="action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12" @click="boostRecommendation(review.ReviewId, 'google')">Boost på google  <i class="fab fa-google"></i>
                  </b-button> -->
                </div>
              </div>
              <div class="mt3" v-else><span class="bold">{{reviewMsg}}</span></div>
            </div>
          </div>
          <!-- Boost confirmation modal -->
          <b-modal id="boost-modal" v-model="modalBoostConfirmation" hide-footer centered no-close-on-esc no-close-on-backdrop>
            <div class="center col-10 py3 mx-auto">
              <div class="mb3">
                <img src="static/svg/question-mark-new.svg" rel="preload" width="25%">
              </div>
              <div class="clearfix">
                <p class="darkblue bold m0">Du er ved at booste din profil på <span class="capitalize">{{boostOption}}</span>.</p>
                <p class="darkblue bold mb3">Ønsker du at forsætte?</p>
                <div class="flex justify-between">
                  <b-button type="button" class="primarycolor-background py2 px3 m0 gibson not-rounded border-none regular col-5" @click="modalBoostConfirmation = false">
                    Naj 
                  </b-button>
                  <b-button type="button" class="action-button  py2 px3 m0 gibson not-rounded border-none regular col-5" @click="boostRecommendation(boostReviewId, boostOption)">
                    Ja
                  </b-button>
                </div>
              </div>
            </div>
          </b-modal>
          <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
          <updatebitrixpackagepermission   ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import {ImageRating} from 'vue-rate-it'
import Simplert from 'vue2-simplert'
import updatebitrixpackagepermission from '../../../components/updatebitrixpackagepermission'
// import axios from 'axios'
export default {
  name: '',
  components: {
    WebshopHeader,
    ImageRating,
    Simplert,
    updatebitrixpackagepermission
  },
  data () {
    return {
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      reviewId: '',
      reviewData: [],
      overviewData: [],
      reviewMsg: '',
      showLess: true,
      boostReviewId: '',
      boostOption: '',
      modalBoostConfirmation: false
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.getOverview()
    var urlStr = window.location.href
    var url = new URL(urlStr.replace('/#', ''))
    var searchParams = url.searchParams
    this.reviewId = searchParams.get('reviewId')
    this.displayRecommendations()
    this.setDefaultAmount()
  },
  methods: {
    showlesss (key) {
      this.showLess = !this.showLess
      if (this.showLess) {
        document.querySelector('span[data-key="' + key + '"]').classList.remove('text-overflow-handle')
      } else {
        document.querySelector('span[data-key="' + key + '"]').classList.add('text-overflow-handle')
      }
    },
    displayRecommendations () {
      var data = {
        operation: 'anbefalingerDetail',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        reviewId: this.reviewId
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res != null) {
            this.reviewData = res
            this.reviewMsg = ''
          } else {
            this.reviewMsg = 'Ingen anbefaling fundet.'
          }
        },
        (response) => {
          console.log('Error in displayRecommendations(): ', response)
        }
      )
      this.insideLoading = true
    },
    getOverview () {
      var dataPartner = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId }
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.data
            this.overviewData = res
          },
          response => {
            this.insideLoading = false
            this.$toastr('error', 'Fejl')
            console.log('Error in getOverview()', response)
          }
        )
    },
    setDefaultAmount () {
      setTimeout(function () {
        document.getElementById('amount').value = '200,00'
      }, 500)
    },
    formatAmount () {
      setTimeout(function () {
        var amount = document.getElementById('amount').value
        if (amount !== '') {
          if (Number.isInteger(parseInt(amount))) {
            var noDotCommaValue = amount.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '')
            var formatter = new Intl.NumberFormat('da', {
              style: 'currency',
              currency: 'DKK',
              minimumFractionDigits: 2
            })
            document.getElementById('amount').value = formatter.format(noDotCommaValue).replace('kr.', '').replace(/\s+/g, '')
          } else {
            document.getElementById('amount').value = ''
          }
        }
      }, 1000)
    },
    addHide () {
      document.getElementById('review').classList.add('hide')
    },
    removeHide () {
      document.getElementById('review').classList.remove('hide')
    },
    imageLoaded () {
      this.removeHide()
      this.insideLoading = false
    },
    confirmBoost (reviewId, option) {
      this.boostReviewId = reviewId
      this.boostOption = option
      this.modalBoostConfirmation = true
    },
    boostRecommendation (reviewId, option) {
      const amount = document.getElementById('amount').value.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '')
      if (amount !== '') {
        if (Number.isInteger(parseInt(amount))) {
          var url = ''
          if (option === 'facebook') {
            url = 'integration/PostRecommendationToFBAd/' + reviewId + '/' + amount
          } else {
            url = 'integration/PostRecommendationToGoogleAd/' + amount + '/' + reviewId
          }
          var data = {
            operation: 'bitrixApi',
            salesPerson: this.salesPerson,
            type: 'POST',
            url: url,
            createinvoice: true,
            price: amount
          }
          this.$http.post('', data, { emulateJSON: true }).then(
            response => {
              var res = response.body
              if (res !== null) {
                if (res.success) {
                  // var adId = res.AdID
                  // Pause ad
                  // this.stopStartAd(adId, option)
                  this.insideLoading = false
                  this.removeHide()
                  this.setDefaultAmount()
                  let obj = {
                    title: 'Dit anmeldelse boost er nu sendt afsted til ' + option + '. Du vil modtage en besked når den er online på ' + option + '.',
                    message: '',
                    type: 'success',
                    customCloseBtnText: 'Luk'
                  }
                  this.$refs.simplert.openSimplert(obj)
                } else {
                  this.insideLoading = false
                  this.removeHide()
                  this.setDefaultAmount()
                  this.$toastr('error', 'Fejl')
                  console.log('Error in boostRecommendation()', response)
                }
              } else {
                this.insideLoading = false
                this.removeHide()
                this.setDefaultAmount()
                this.$toastr('error', 'Allerede boostet')
                console.log('Error in boostRecommendation()', response)
              }
            },
            response => {
              this.insideLoading = false
              this.removeHide()
              this.setDefaultAmount()
              this.$toastr('error', 'Fejl')
              console.log('Error in boostRecommendation()', response)
            }
          )
          this.modalBoostConfirmation = false
          this.insideLoading = true
          this.addHide()
        } else {
          this.$toastr('error', 'Ugyldigt beløb')
        }
      } else {
        this.$toastr('error', 'Indtast beløb')
      }
    }
    // stopStartAd (adId, option) {
    //   var url = ''
    //   if (option === 'facebook') {
    //     url = 'integration/PauseFbAd/' + adId
    //   } else {
    //     url = ''
    //   }
    //   var data = {
    //     operation: 'bitrixApi',
    //     salesPerson: this.salesPerson,
    //     type: 'POST',
    //     url: url
    //   }
    //   this.$http.post('', data, { emulateJSON: true }).then(
    //     (response) => {
    //       var res = response.body
    //       if (res.success) {
    //         this.insideLoading = false
    //         this.removeHide()
    //         this.setDefaultAmount()
    //         this.$toastr('success', 'Gennemført')
    //       } else {
    //         this.insideLoading = false
    //         this.removeHide()
    //         this.setDefaultAmount()
    //         this.$toastr('error', 'Fejl')
    //         console.log('Error in stopStartAd()', response)
    //       }
    //     },
    //     (response) => {
    //       this.insideLoading = false
    //       this.removeHide()
    //       this.setDefaultAmount()
    //       this.$toastr('error', 'Fejl')
    //       console.log('Error in stopStartAd()', response)
    //     }
    //   )
    // }
  }
}
</script>
<style>
.text-overflow-handle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}
  #boost-anbefaling .el-collapse-item .el-collapse-item__header {
    font-size: 1rem;
    font-weight: bold;
    border: none;
    color: #003645;
  }
  #boost-anbefaling .el-collapse-item__content {
    font-size: 1rem; 
  }
  #boost-anbefaling .el-collapse-item .el-collapse-item__wrap {
    border-bottom: none;
  }
  @media (max-width: 64em) {
    #boost-anbefaling .col-12.flex > div.lg-col-3 {
      padding-right: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// BoostEnAnbefaling.vue?aa5372b0